'use strict';
var _ = require('lodash');
var moment = require('moment');

module.exports = function (tenantId, matchingNumber, batchNumber) {
  if (_.isNil(tenantId) || _.isNil(matchingNumber) || _.isNil(batchNumber)) {
    return;
  }

  var date = moment().format('YYYYMMDDHHmmss');

  return [tenantId, matchingNumber, date, _.padStart(batchNumber, 3, 0)].join('');
};
